import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from './';
import styled from 'styled-components';

import Postcode from './search/location';

const LocationInputCol = Col.extend`
  position: relative;
  @media (min-width: ${props => props.theme.breakpoints.xs}rem) {
    padding: 0;
  }
`;

const LocationInput = Postcode.extend`
  input {
    margin: 0;
    padding: 10px 20px;
    border-radius: 4px;
    border: 0;
    font-size: 16px;
    ::-webkit-input-placeholder {
      @media (max-width: ${props => props.theme.breakpoints.md}rem) {
        font-size: 16px;
      }
    }
  }
`;

const ButtonCol = Col.extend`
  @media (max-width: ${props => props.theme.breakpoints.md}rem) {
    padding: 0;
    margin-top: 10px;
  }
`;

const ButtonStyle = Button.extend`
  padding: 12px 10px;
  height: 100%;
  min-height: 20px;
  line-height: 20px;
`;

const ButtonIconStyle = styled.img`
  vertical-align: middle;
  margin-right: 5px;
`;

export const LocationType = PropTypes.shape({
  suburb: PropTypes.string,
  postcode: PropTypes.string
});

export class LocationAutocomplete extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onBlurAutosuggest: PropTypes.func,
    onFocusLocation: PropTypes.func,
    onBlurLocation: PropTypes.func,
    onButtonClick: PropTypes.func,
    initialLocation: LocationType,
    onLocationDidChange: PropTypes.func,
    postcodePlaceholder: PropTypes.string,
    actionUrl: PropTypes.string,
    center: PropTypes.bool,
    buttonStyle: PropTypes.string,
    buttonText: PropTypes.string,
    buttonIcon: PropTypes.string,
    className: PropTypes.string,
    inputProps: PropTypes.object
  };

  static defaultProps = {
    onSubmit: url => (window.location = url)
  };

  state = {
    postcodeValue: '',
    locationSelection: null,
    suggestionValue: ''
  };

  constructor(props) {
    super(props);
    const { initialLocation } = this.props;
    if (initialLocation) {
      if (initialLocation.suburb && initialLocation.postcode) {
        this.state.postcodeValue = `${initialLocation.suburb} - ${initialLocation.postcode}`;
      } else if (initialLocation.postcode) {
        this.state.postcodeValue = initialLocation.postcode;
      }
      this.state.locationSelection = initialLocation;
    }
  }

  onChangePostcode = postcodeValue => {
    this.setState({ postcodeValue });
    if (!postcodeValue) this.props.onLocationDidChange();
  };

  onPostcodeSelected = (event, { suggestion, suggestionValue }) => {
    this.setState({
      location: suggestionValue,
      locationSelection: suggestion,
      postcodeValue: `${suggestion.postcode} - ${suggestion.suburb}`
    });
    this.props.onLocationDidChange &&
      this.props.onLocationDidChange(suggestion, `${suggestion.postcode} - ${suggestion.suburb}`);
    setTimeout(() => {
      this.submitLocation();
    }, 0);
  };

  submitLocation = () => {
    const { postcodeValue } = this.state;
    const { actionUrl } = this.props;
    if (actionUrl && postcodeValue) {
      const locQuery = postcodeValue ? `?w=${postcodeValue}` : '';
      this.props.onSubmit(`${actionUrl}${locQuery}`, postcodeValue);
    } else if (actionUrl) {
      this.props.onSubmit(`${actionUrl}`);
    }
  };

  onSubmit = e => {
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
    this.submitLocation();
  };

  render() {
    const { postcodeValue } = this.state;
    const {
      onFocusLocation,
      onBlurLocation,
      postcodePlaceholder,
      buttonText,
      className,
      actionUrl,
      center,
      buttonStyle,
      buttonIcon,
      inputProps
    } = this.props;

    return (
      <form
        action={actionUrl}
        onSubmit={this.onSubmit}
        ref={form => (this.form = form)}
        className={className}
      >
        <Col xs={12}>
          <Row center={center ? 1 : 0}>
            <LocationInputCol xs={12} md={center ? 6 : 7} lg={center ? 4 : 7}>
              <LocationInput
                id="postcode-search"
                name="w"
                placeholder={postcodePlaceholder || 'Enter postcode'}
                value={postcodeValue}
                onSuggestionSelected={this.onPostcodeSelected}
                onChange={this.onChangePostcode}
                onFocus={onFocusLocation}
                onBlur={onBlurLocation}
                inputProps={inputProps}
              />
            </LocationInputCol>
            <ButtonCol xs={12} md={center ? 3 : 5} lg={center ? 3 : 5}>
              <ButtonStyle
                secondary={buttonStyle === 'secondary'}
                primary={buttonStyle === 'primary'}
                block
                type="submit"
              >
                {buttonIcon && <ButtonIconStyle src={buttonIcon} />}
                {buttonText || 'Get Quotes'}
              </ButtonStyle>
            </ButtonCol>
          </Row>
        </Col>
      </form>
    );
  }
}
